import { render, staticRenderFns } from "./CarnotCycleViz.vue?vue&type=template&id=2d223f34&scoped=true"
import script from "./CarnotCycleViz.vue?vue&type=script&lang=js"
export * from "./CarnotCycleViz.vue?vue&type=script&lang=js"
import style0 from "./CarnotCycleViz.vue?vue&type=style&index=0&id=2d223f34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d223f34",
  null
  
)

export default component.exports